export const getSnapshotsForResource = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      snapshots {
        id
        sk
        idInc
        name
        workspaceId
        isPublished
        createdAt
      }
    }
  }
`;

export const createSnapshot = /* GraphQL */ `
  mutation CreateSnapshot($input: CreateSnapshotInput!) {
    createSnapshot(input: $input) {
      id
      sk
    }
  }
`;

export const restoreSnapshot = /* GraphQL */ `
  mutation RestoreSnapshot($input: RestoreSnapshotInput!) {
    restoreSnapshot(input: $input) {
      id
      sk
    }
  }
`;

export const deleteSnapshot = /* GraphQL */ `
  mutation DeleteResource($input: DeleteSnapshotInput!) {
    deleteSnapshot(input: $input) {
      id
      sk
    }
  }
`;
